module.exports = __webpack_public_path__ + "img/1.13a7663c.jpg";